function listenerForAtcAndWichlist(){
  
  let timeInterval = setInterval(() => {
    
    let wislistArray = document.querySelectorAll('.swym-button.swym-add-to-wishlist-view-product svg, .swym-button.swym-add-to-wishlist svg');
    
    let quicAddToCartArray = document.querySelectorAll('.addCartCstm:not(.active-event)');
    
    if(wislistArray.length > 0){
      clearInterval(timeInterval);
      // console.log(wislistArray)
      wislistArray.forEach(item => {
        if (!item.classList.contains('active-event')) {
          item.classList.add('active-event');
          if (item.closest('.product__info-wrapper'))
          {
            item.addEventListener('click', function(e) {
              let gtmPayload = this.closest('.product__info-wrapper').querySelector('.gtmPayload').value;
              
              gtmPayload = JSON.parse(gtmPayload)
              gtmPayload.event = 'add_to_wishlist';
              window.dataLayer.push({ ecommerce: null });
              window.dataLayer.push(gtmPayload);
            })
          }
          
        }
      })
    }

  
    if(quicAddToCartArray.length > 0){
      clearInterval(timeInterval);
      quicAddToCartArray.forEach(item => {
        if (!item.classList.contains('active-event')) {
          item.classList.add('active-event');
          item.addEventListener('click', function(e) {
            
            // console.log(this)
            let gtmPayload = this.closest('.product-card-wrapper').querySelector('.gtmPayload').value;
            gtmPayload = JSON.parse(gtmPayload)
            if(gtmPayload){
              gtmPayload.event = 'add_to_cart';
              window.dataLayer.push({ ecommerce: null });
              window.dataLayer.push(gtmPayload);
            }
          })
        }
      })
    }
  }, 300)
  
}
window.listenerForAtcAndWichlist = listenerForAtcAndWichlist

function viewItemEvent(el) {
  let gtmPayload = el
    .closest('.product__info-wrapper')
    .querySelector('.gtmPayload').value;

  gtmPayload = JSON.parse(gtmPayload);

  // Change event if needed
  gtmPayload.event = 'view_item';

  window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push(gtmPayload);
}
window.viewItemEvent = viewItemEvent

function addToCartEvent(){
  let productPageATC = document.querySelector('[data-type="add-to-cart-form"]');
  if (productPageATC){
    productPageATC.addEventListener('submit', function(e) {
      let gtmPayload = document.querySelector('.product__info-wrapper').querySelector('.gtmPayload').value;
      gtmPayload = JSON.parse(gtmPayload)
      if(gtmPayload){
        gtmPayload.event = 'add_to_cart';
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push(gtmPayload);
      }
    })
  }
}
document.addEventListener("DOMContentLoaded", (event) => {
  listenerForAtcAndWichlist();
  addToCartEvent();

  function gtmClickCard() {
    // console.log('Click GTM Card')
    let productCardList = document.querySelectorAll('.product-card-wrapper');
    productCardList.forEach(item => {
      if (!item.classList.contains('active-event')) {
        item.classList.add('active-event');
        item.querySelectorAll('a.product-link-main').forEach(aEL => {
          aEL.addEventListener('click', (e) => {
            e.preventDefault();
            let redirectURL = aEL.href
            try {
              let redirectURL = aEL.href
              let rawPayload = JSON.parse(aEL.closest('.product-card-wrapper').querySelector('.gtmPayload').value)
              let deblicatePayload = Object.assign({}, rawPayload);
              deblicatePayload.event = "select_item",
                
              delete deblicatePayload.ecommerce.currency
              delete deblicatePayload.ecommerce.value
  
              deblicatePayload.ecommerce['item_list_id'] = rawPayload.ecommerce.items[0].item_list_id
              deblicatePayload.ecommerce['item_list_name'] = rawPayload.ecommerce.items[0].item_list_name
  
              // console.log(deblicatePayload)
              window.dataLayer.push({ ecommerce: null });
              window.dataLayer.push(deblicatePayload);
              window.location.href = redirectURL
            } catch (error) {
              // console.log('gtmClickCard Error:', error)
              window.location.href = redirectURL;
            }
            
          })
        })
      }
    })
  }

  gtmClickCard();
  window.gtmClickCard = gtmClickCard;
});

function gtmMainCartEvent(row, eventName, quantityDiff) {
  let gtmPayload = row.querySelector('.gtmPayload')?.value;

  if (!gtmPayload) return;

  gtmPayload = JSON.parse(gtmPayload);
  gtmPayload.event = eventName;

  if (quantityDiff != null) {
    gtmPayload.ecommerce.items[0].quantity = quantityDiff;
  }

  window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push(gtmPayload);
}

window.gtmMainCartEvent = gtmMainCartEvent;


function gtm_removeFromCart(e, quantityDiff) {
  let gtmPayload = e.closest('li')?.querySelector('.gtmPayload')?.value;

  if (gtmPayload) {
    gtmPayload = JSON.parse(gtmPayload);
    gtmPayload.event = 'remove_from_cart';

    // Only override quantity if provided
    if (quantityDiff != null) {
      gtmPayload.ecommerce.items[0].quantity = quantityDiff;
    }

    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push(gtmPayload);
  }
}

window.gtm_removeFromCart = gtm_removeFromCart;

function gtm_addToCart(e, quantityDiff) {
  let gtmPayload = e.closest('li')?.querySelector('.gtmPayload')?.value;

  if (gtmPayload) {
    gtmPayload = JSON.parse(gtmPayload);
    gtmPayload.event = 'add_to_cart';

    // Only override quantity if provided
    if (quantityDiff != null) {
      gtmPayload.ecommerce.items[0].quantity = quantityDiff;
    }

    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push(gtmPayload);
  }
}

window.gtm_addToCart = gtm_addToCart;


async function pushViewCartEvent() {
  try {
    const response = await fetch(`${window.Shopify.routes.root}?sections=main-cart-items`);
    const sections = await response.json();

    const html = new DOMParser().parseFromString(
      sections['main-cart-items'],
      'text/html'
    );

    const payloadInput = html.querySelector('.gtmPayload.main-cart-gtm');

    if (!payloadInput) return;

    const gtmPayload = JSON.parse(payloadInput.value);

    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push(gtmPayload);
  } catch (error) {
    console.error('Failed to push view_cart event:', error);
  }
}

window.pushViewCartEvent = pushViewCartEvent;